import i18n from "../internationalization/i18n";

/**
 * Hook-free price formatting: the only form safe to call outside of JSX
 * (e.g. as an i18n interpolation value) — calling the DisplayPrice component
 * as a plain function would register its hooks in the caller and break hook
 * counts. Amount is in cents.
 */
export function formatPriceText({
  amount,
  taxFree,
  addon,
  currency = "EUR",
  withSign,
}: {
  amount: number;
  // if undefined, no taxFree display, if true, display HT, if false, display TTC
  taxFree?: boolean;
  addon?: string;
  currency?: string;
  withSign?: boolean;
}): string {
  const language = i18n.language;
  const parts = Intl.NumberFormat(language, {
    style: "currency",
    currency: currency,
  }).formatToParts(amount / 100);

  const formatedPrice = parts
    .filter((part) => part.type !== "currency")
    .map((part) => part.value)
    .join("")
    .split(language === "fr" ? "," : ".");
  const currencyValue =
    parts.find((part) => part.type === "currency")?.value ?? "€";
  const currencyPosition =
    parts.findIndex((part) => part.type === "currency") === 0
      ? "before"
      : "after";

  let priceAsText = "";
  if (currencyPosition === "before") priceAsText += currencyValue;
  if (withSign && amount > 0) priceAsText += "+";
  priceAsText += formatedPrice[0];
  if (formatedPrice[1] && Number(formatedPrice[1]) > 0)
    priceAsText += `,${formatedPrice[1]}`;
  if (currencyPosition === "after") priceAsText += `${currencyValue} `;
  if (taxFree === true) priceAsText += ` ${i18n.t("common:HT")}`;
  else if (taxFree === false) priceAsText += ` ${i18n.t("common:TTC")}`;
  if (addon) priceAsText += ` ${addon}`;

  return priceAsText;
}
